import React from "react";
import Splider from "../Components/Splider";
import PrevEvents from "../Components/PrevEvents";
import NextEvents from "../Components/nextEvents";
import HomeAboutUs from "../Components/HomeAboutUs";
import CommentSection from "../Components/CommentSection";

function Home() {
  return (
    <React.Fragment>
      <Splider />
      <HomeAboutUs />
      <NextEvents />
      <PrevEvents />
      <CommentSection />
    </React.Fragment>
  );
}

export default Home;
